

















import 'reflect-metadata'
import {Vue,Prop,Component,Emit,Watch} from "vue-property-decorator";


@Component
export default class Nav extends Vue {

  $refs!: {
    stickyNav: HTMLElement,
    filler: HTMLElement,
  }

  shouldFill: boolean = false; // 判断导航fixed定位后的填充
  nav: any = null;

  @Prop() navList!:Array<any>;
  @Prop() bannerHeight!:number;
  navActiveIndex = 0;

  created() {

  }

  mounted(){
    this.nav = this.$refs.stickyNav;
    document.addEventListener('scroll', ()=>{
      if(window.scrollY >= this.bannerHeight){
        this.nav.classList.add('sticky');
        this.shouldFill = true;
      }else{
        this.nav.classList.remove('sticky');
        this.shouldFill = false;
      }
    });
  }

  beforeDestroy(){
    this.nav.classList.remove('sticky');
    this.shouldFill = false;
  }

  @Emit()
  selectChange(item:any, index: number) {
      if(this.navActiveIndex !== index){  // 避免重复跳转
        this.navActiveIndex = index;
        // 导航条悬浮时，跳转回到导航条悬浮临界的位置
        if(this.$refs.filler) {
          document.body.scrollTop = document.documentElement.scrollTop = this.$refs.filler.offsetTop - 75;
        }
        return index;
      }
      return null;
  }
}
